var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{ref:"el",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.items),function(item){return [_c('swiper-slide',{key:item.id},[_c('CategoryCard',{attrs:{"tag":item}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }